import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { Router } from '@angular/router';

@Component({
    selector: 'app-menuadmin',
    templateUrl: './menuadmin.component.html',
    styleUrls: ['./menuadmin.component.scss'],
})
export class MenuAdminComponent implements OnInit {

    constructor(
        private navCtrl: NavController,
        public router: Router,
    ) { }

    ngOnInit() {}

    public goTo(path) {
        // this.navCtrl.navigateForward(path);
        this.router.navigate([path])
    }

}
